import fetch from '@strictsoftware/fetch';
const defaultConfiguration = {
    createLogger: () => console,
    getFetchWithTracing: () => fetch,
    recordOutgoingMetrics: () => () => undefined,
};
let configuration;
export function setup(config) {
    configuration = config;
}
export function createLogger(name) {
    return {
        error: (...args) => getLogger(name).error(...args),
        warn: (...args) => getLogger(name).warn(...args),
        info: (...args) => getLogger(name).info(...args),
        trace: (...args) => getLogger(name).trace(...args),
    };
}
const loggers = {};
/**
 * Because of the configurability, we can't create a logger at the top of each file that needs it and be done with it
 * because at that time the configuration probably didn't happen yet. Instead get the logger each time you need it.
 *
 * Do not cache the result at module level!
 */
function getLogger(name) {
    if (!loggers[name]) {
        const create = (configuration && configuration.createLogger) ||
            defaultConfiguration.createLogger;
        loggers[name] = create(name);
    }
    return loggers[name];
}
export function getFetchWithTracing(serviceName) {
    const get = (configuration && configuration.getFetchWithTracing) ||
        defaultConfiguration.getFetchWithTracing;
    return get(serviceName);
}
export function recordOutgoingMetrics(serviceName) {
    const record = (configuration && configuration.recordOutgoingMetrics) ||
        defaultConfiguration.recordOutgoingMetrics;
    return record(serviceName);
}
